import apiClient from 'hub-http/clients/apiClient';
import { fromJS } from 'immutable';
import I18n from 'I18n';
import QuoteRecord from 'customer-data-objects/quote/QuoteRecord';
import { getQuoteId, getQuoteProperty, mergeQuoteProperties } from 'quotes-ui-lib/utils/utils';
import downloadPdfClient from 'quotes-ui-lib/api/clients/downloadPdfClient';
import quotePublishedStatusClient from 'quotes-ui-lib/api/clients/quotePublishedStatusClient';
// @ts-expect-error untyped module
import { catchAndRethrowNetworkError } from 'quotes-ui-lib/api/monitoring/errorUtils';
import { getQuotePayload } from './utils/quotesApi';
import { QUOTES, CRM_UI } from 'customer-data-objects/property/PropertySourceTypes';
export { getQuotePayload };
const HEADERS = {
  'X-Properties-Source': QUOTES,
  'X-Properties-SourceId': CRM_UI
};
export function updatePublishedQuote(quoteId, propertyName, propertyValue) {
  return apiClient.patch(`inbounddbquotes/v1/published-quotes/${quoteId}/property-update`, {
    data: {
      propertyName,
      propertyValue
    }
  });
}
function maybePollForPublished(quoteResponse) {
  const isPublishedStatus = getQuoteProperty(quoteResponse, 'hs_status') === 'APPROVED' || getQuoteProperty(quoteResponse, 'hs_status') === 'APPROVAL_NOT_NEEDED';
  if (isPublishedStatus) {
    return quotePublishedStatusClient.get(`inbounddbquotes/v1/quotes/${quoteResponse.quote.objectId}/with-associated-objects?fetch-associated-objects=true`).then(QuoteRecord.fromJS).catch(catchAndRethrowNetworkError);
  }
  return quoteResponse;
}
export function createQuote(quote) {
  const requestBody = getQuotePayload(quote);
  return apiClient.post('inbounddbquotes/v1/quotes/with-associated-objects', {
    headers: HEADERS,
    data: requestBody.toJS()
  }).then(QuoteRecord.fromJS).catch(catchAndRethrowNetworkError);
}
export function deleteQuote(quote) {
  const id = getQuoteId(quote);
  return apiClient.delete(`inbounddbquotes/v1/quotes/${id}`, {
    headers: HEADERS
  }).catch(catchAndRethrowNetworkError);
}
export function updateAndMaybePollForPublished(quote) {
  const id = getQuoteId(quote);
  const requestBody = getQuotePayload(quote);
  return apiClient.put(`inbounddbquotes/v1/quotes/${id}/with-associated-objects`, {
    headers: HEADERS,
    data: requestBody.toJS()
  }).then(res => QuoteRecord.fromJS(res)).then(maybePollForPublished).catch(catchAndRethrowNetworkError);
}
export function clone(quote) {
  const quoteId = getQuoteId(quote);
  const title = getQuoteProperty(quote, 'hs_title');
  const expirationDate = getQuoteProperty(quote, 'hs_expiration_date');
  const requestBody = {
    quoteId,
    quoteTitle: `${title} (${I18n.text('quotesUiLib.api.copy')})`,
    expirationDate
  };
  return apiClient.post('inbounddbquotes/v1/quotes/with-associated-objects/clone', {
    headers: HEADERS,
    data: requestBody
  }).then(QuoteRecord.fromJS).catch(catchAndRethrowNetworkError);
}
export function recallPublished(quote) {
  const id = getQuoteId(quote);
  return apiClient.post(`inbounddbquotes/v1/quotes/${id}/recall`, {
    headers: HEADERS
  }).then(QuoteRecord.fromJS).catch(catchAndRethrowNetworkError);
}
export function approveAndPollForPublished(quote) {
  const id = getQuoteId(quote);
  const requestBody = getQuotePayload(mergeQuoteProperties(quote, {
    hs_status: 'APPROVED'
  }));
  return apiClient.put(`inbounddbquotes/v1/quotes/${id}/with-associated-objects`, {
    headers: HEADERS,
    data: requestBody.toJS()
  }).then(QuoteRecord.fromJS).then(maybePollForPublished).catch(catchAndRethrowNetworkError);
}
export function requestChanges(quote, feedback) {
  const id = getQuoteId(quote);
  const requestBody = getQuotePayload(mergeQuoteProperties(quote, {
    hs_status: 'REJECTED',
    hs_feedback: feedback
  }));
  return apiClient.put(`inbounddbquotes/v1/quotes/${id}/with-associated-objects`, {
    headers: HEADERS,
    data: requestBody.toJS()
  }).then(QuoteRecord.fromJS).catch(catchAndRethrowNetworkError);
}
export function fetchQuoteEsignBatch(publicUrlKeys) {
  return apiClient.get(`inbounddbquotes/v1/esign/batch`, {
    query: {
      publicUrlKey: publicUrlKeys
    },
    headers: HEADERS
  }).catch(catchAndRethrowNetworkError);
}
export function getQuoteDownloadUrl(quoteId) {
  return downloadPdfClient.get(`inbounddbquotes/v1/downloads/${quoteId}/pdf`).then(fromJS).catch(catchAndRethrowNetworkError);
}
export function viewQuotePdf(quoteId) {
  return apiClient.get(`inbounddbquotes/v1/downloads/${quoteId}/pdf/view`).then(fromJS).catch(catchAndRethrowNetworkError);
}
export function fetchCountersignerDetails(publicUrlKey) {
  return apiClient.get(`inbounddbquotes/v1/esign/signatureDetails/${publicUrlKey}/counterSigner`);
}